import { render, staticRenderFns } from "./cardWithIcon.vue?vue&type=template&id=b2601ca8&"
import script from "./cardWithIcon.vue?vue&type=script&lang=js&"
export * from "./cardWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports